import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EcosystemAPI, mapServerError } from "../../lib/ecosystemApi";
import { LifecycleChip, EnhancedChip } from "../../components/ecosystem/Chips";

export default function ReviewQueue() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState(null);
  useEffect(() => { EcosystemAPI.list().then((rows) => setItems(rows.filter((r) => r.lifecycle_state === "REVIEW"))).catch((e) => setErr(mapServerError(e))); }, []);

  const enhanced = items.filter((i) => i.safety_classification?.enhanced_review);
  const standard = items.filter((i) => !i.safety_classification?.enhanced_review);

  return (
    <div className="space-y-4" data-testid="ecosystem-review-queue">
      <h1 className="text-2xl font-semibold">Review queue</h1>
      {err && <div className="text-sm text-red-700">{err}</div>}
      {items.length === 0 && !err && <div className="text-sm text-slate-500">The queue is empty.</div>}

      {enhanced.length > 0 && (
        <section data-testid="review-queue-enhanced" className="border-l-4 border-amber-400 pl-3">
          <h2 className="text-sm font-medium text-amber-900 mb-2">Enhanced review — priority</h2>
          <QueueList items={enhanced} />
        </section>
      )}
      {standard.length > 0 && (
        <section data-testid="review-queue-standard">
          <h2 className="text-sm font-medium text-slate-600 mb-2">Standard review</h2>
          <QueueList items={standard} />
        </section>
      )}
    </div>
  );
}

function QueueList({ items }) {
  return (
    <ul className="space-y-2">
      {items.map((i) => (
        <li key={i.id} data-testid={`review-row-${i.id}`} className="bg-white p-3 rounded border flex items-center gap-3">
          <span className="text-xs text-slate-400 uppercase">{i.entity_type}</span>
          <EnhancedChip classification={i.safety_classification} />
          <Link to={`/ecosystem/entities/${i.id}`} className="font-medium hover:underline">{i.canonical_name}</Link>
          <LifecycleChip state={i.lifecycle_state} />
          <span className="text-xs text-slate-500 ml-auto">v{i.current_version} · created by {i.created_by}</span>
        </li>
      ))}
    </ul>
  );
}
